
import React from "react";
import { Link } from "react-router-dom";

const NavbarBrand: React.FC = () => {
  return (
    <Link to="/" className="relative z-10 flex-shrink-0 flex items-center" aria-label="Propmatch inicio">
      <img 
        src="/lovable-uploads/c86e0fea-aa25-4a30-9b66-9a26a3c2ba1e.png" 
        alt="Propmatch Logo" 
        className="h-12 sm:h-12 md:h-12 lg:h-14 xl:h-16 w-auto transition-all duration-200 translate-y-[-6px]" 
        width="160"
        height="64"
      />
    </Link>
  );
};

export default NavbarBrand;
